export enum CloudTaskQueue {
    AGGREGATE_BROADCAST_PERSON_STATS = 'aggregate-broadcast-person-stats',
    'asana-api' = 'asana-api',
    BATCH_ENROLLMENT_PROCESSING = 'batch-enrollment-processing',
    BATCH_REFRESH_TOKENS = 'batch-refresh-tokens',
    BATCH_REVIEW_SCRAPE = 'batch-review-scrape',
    'batch-stripe-customer-updated' = 'batch-stripe-customer-updated',
    'batch-stripe-subscription-updated' = 'batch-stripe-subscription-updated',
    BULK_PEOPLE_ACTIONS = 'bulk-people-actions',
    CAMPAIGN_REQUEST = 'campaign-request',
    COMPANY_BACKFILL = 'company-backfill',
    CREATE_REVIEWS = 'create-reviews',
    BATCH_COMPETITORS_REVIEW_SCRAPE = 'batch-competitors-review-scrape',
    'create-convert' = 'create-convert',
    'default' = 'default',
    'get-insights' = 'get-insights',
    AUTO_REPLY_REVIEW = 'auto-reply-review',
    GIFT_REPORT = 'gift-report',
    GOOGLE_ANALYTICS_API = 'google-analytics-api',
    GOOGLE_API_SCRAPE_QUEUE = 'google-api-scrape-queue',
    SCRAPING_HUB_API_QUEUE = 'scraping-hub-api-queue',
    EVALUATE_GIFT_INTENTS = 'evaluate-gift-intents',
    IMPORT_INTEGRATION_DATA = 'import-integration-data',
    SYNC_REVIEW_DATA_ALL_PEOPLE = 'sync-review-data-all-people',
    SYNC_REVIEW_DATA = 'sync-review-data',
    'intercom-api' = 'intercom-api',
    MAX_UNITS = 'max-units',
    'nudge-company-entities' = 'nudge-company-entities',
    OPPORTUNITIES = 'opportunities',
    PAYMENT_REPORT_EXPORT = 'payment-report-export',
    PROCESS_ALL_SUBJECTS = 'process-all-subjects',
    PROCESS_UNPROCESSED_REVIEWS = 'process-unprocessed-reviews',
    REINSTATE_REVIEWS = 'reinstate-reviews',
    SEND_MESSAGE = 'send-message',
    'schedule' = 'schedule',
    'scrape-reviews' = 'scrape-reviews',
    'story-auto-share' = 'story-auto-share',
    SYNC_ALL_INTERCOM_DATA = 'syncAllIntercomData',
    TEXT_EMBEDDING = 'text-embedding-005',
    BATCH_TEXT_EMBEDDINGS_PROCESS = 'batch-text-embeddings-process',
    UPDATE_REVIEWS = 'update-reviews',
    DELETE_REVIEWS = 'delete-reviews',
    UPDATE_REVIEW_STATS = 'update-review-stats',
    VERTEX_AI = 'vertex-ai',
}
